import {getStack} from '@ns/ns-contentstack-lib';
// import axios from 'axios';
import {UrlService} from '@nuskin/ns-util';

const cartContentTypes = [
    'cart_ageloc_strings',
    'cart_general_strings',
    'cart_loyalty_strings',
    'cart_ops_strings',
    'cart_scan_card_strings',
    'cart_search_strings'
];

/** @type {undefined | Promise<any>} */
let stringsPromise;

let stringsMap;

/**
 * @return {Promise<any>}
 */
export async function getStrings() {
    if (stringsMap) return stringsMap;

    if (stringsPromise) return stringsPromise;

    stringsPromise = getStringsFromContentstack();

    return stringsPromise;
}

/**
 * @return {Promise<any>}
 */
async function getStringsFromContentstack() {
    const [language, country] = UrlService.getLocaleFromUrl();
    const mappedLanguage = language === 'in' ? 'id' : language;

    const stringsList = await getStack().getSingletonEntries({
        contentTypeUIDs: cartContentTypes,
        country,
        language: mappedLanguage,
        camelcase: true,
        mergeWithFallback: true
    });

    // Merge all the strings into a single object instead of an array of objects
    stringsMap = stringsList.reduce((result, current) => {
        return Object.assign(result, current);
    }, {});

    // Perform a bit of key cleanup (some keys couldn't be copied 1:1 from AEM to Contentstack)
    stringsMap['CUST.userTierNameT1'] = stringsMap.custUserTierNameT1;
    stringsMap['CUST.userTierNameT2'] = stringsMap.custUserTierNameT2;
    stringsMap['CUST.userTierNameT3'] = stringsMap.custUserTierNameT3;
    stringsMap['CUST.userTierNameT4'] = stringsMap.custUserTierNameT4;
    stringsMap['DIST.userTierNameT1'] = stringsMap.distUserTierNameT1;
    stringsMap['DIST.userTierNameT2'] = stringsMap.distUserTierNameT2;
    stringsMap['DIST.userTierNameT3'] = stringsMap.distUserTierNameT3;
    stringsMap['DIST.userTierNameT4'] = stringsMap.distUserTierNameT4;
    stringsMap['PREF.userTierNameT1'] = stringsMap.prefUserTierNameT1;
    stringsMap['PREF.userTierNameT2'] = stringsMap.prefUserTierNameT2;
    stringsMap['PREF.userTierNameT3'] = stringsMap.prefUserTierNameT3;
    stringsMap['PREF.userTierNameT4'] = stringsMap.prefUserTierNameT4;

    return stringsMap;
}
